// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3JE_K","overflowing":"ReadFullNote_overflowing__1QttP"};